import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import { AttributeMonitorContext } from "csi/heading/AttributeMonitor";
import Enum from "csi/heading/Enum";
import stateColorResolver from "csi/heading/stateColorResolver";
import { C8AttributeValue } from "csi/typings";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const StateColorRenderer = declare(Enum, {
	// should be rendered as upper case text
	capitalized: true,

	/**
	 * @override
	 * Apply the styling if needed
	 */
	_getRenderCSS(ctx: Context, h: Heading): string {
		let node = ctx.getNode();
		if (!node) {
			return this.inherited<string>(arguments);
		}

		if (xml.isValidURL(node.CurrentRevision)) {
			node = ctx.cache.getNode(node.CurrentRevision);
		}

		return this.inherited(arguments) + " " + stateColorResolver.getStateCss(node);
	},

	/**
	 * @override
	 * Redraw row when updated
	 */
	onMonitor(amc: AttributeMonitorContext, newValue: C8AttributeValue) {
		amc.ctx.view.redrawNode(amc.refNode);
		return true;
	},

	/**
	 * @override
	 * Monitor changes to status if pending or active
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element, actionData: ActionData): boolean {
		const value = this._getValue(ctx, h);

		if (xml.enumGetText(value) === "Generating") {
			this.monitor(ctx, h, refNode, value);
		}

		return this.inherited<boolean>(arguments);
	},
});

export = StateColorRenderer;